import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ isDragging: boolean; isEmpty: boolean }>`
  position: relative;

  ${({ isEmpty }) =>
    isEmpty &&
    css`
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      background: #fafafa;
    `}

  ${({ isDragging, isEmpty }) =>
    isDragging &&
    isEmpty &&
    css`
      background: #f6efff;
      border-color: #953fff;
    `}

  ${({ isDragging, isEmpty }) =>
    isDragging &&
    !isEmpty &&
    css`
      &:before {
        pointer-events: none;
        position: absolute;
        z-index: 99999;
        display: block;
        top: 0;
        left: -4px;
        right: -4px;
        bottom: 0;
        content: '';
        background: #f6efff;
        border: 2px solid #953fff;
        border-radius: 4px;
        opacity: 0.56;
      }
    `}
`;

export const WrapperInner = styled.div<{ isDragging: boolean }>`
  ${({ isDragging }) =>
    isDragging &&
    css`
      pointer-events: none;
    `}
`;

export const Input = styled.input`
  display: none;
`;
